import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilsService } from "../../../../auth/service/utils.service";
import { CustomerService } from "../../../../modules/customer/customer.service";
import { AuthenticationService } from "../../../../auth/service";

@Component({
  selector: 'app-form-add-customer-referent',
  templateUrl: './form-add-customer-referent.component.html',
  styleUrls: ['./form-add-customer-referent.component.scss'],
})
export class FormAddCustomerReferentComponent implements OnInit {
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();

  @Output() onAdd: EventEmitter<any> = new EventEmitter();

  @ViewChild('addNewReferent') addNewReferentModal: ElementRef;

  @Input() clientID: number = 0;

  public formGroupAdd: FormGroup;

  public addressesList: any = [];

  private showErrors: any = false;

  constructor(
    public _utilService: UtilsService,
    public _modalService: NgbModal,
    private _formBuilder: FormBuilder,
    public customerService: CustomerService,
    public _authenticationService: AuthenticationService,
  ) {
    this.formGroupAdd = this._formBuilder.group({
      client: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      site: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      firstname: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      lastname: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      email: new FormControl('', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
      phone: new FormControl(''),
    });
  }

  async ngOnInit() {
    setTimeout(() => this.openModal());
    if (this.clientID > 0) {
      this.formGroupAdd.patchValue({
        client: this.clientID,
      });
      this.filterAddresses();
    }
  }

  openModal() {
    this._modalService.open(this.addNewReferentModal, {
      centered: true,
      size: 'lg',
      backdrop: false,
      keyboard: false,
    });
  }

  filterAddresses() {
    this.formGroupAdd.patchValue({ site: null });
    const clientID: number = this.formGroupAdd.value.client;
    this.addressesList = this.customerService.addresses.filter((address: any) => {
      return address?.client?.id === clientID;
    });
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return (this.formGroupAdd.controls[field_name].status === 'INVALID');
    } else {
      return (this.formGroupAdd.controls[field_name].status === 'INVALID' && this.formGroupAdd.controls[field_name].touched);
    }
  }

  async add() {
    this.showErrors = true;
    // controllo valori
    if (this.formGroupAdd.invalid) {
      return false;
    }
    this._utilService.showLoading();
    await this.customerService.addReferent(this.formGroupAdd.value)
      .then(async (response: any) => {
        this._utilService.hideLoading();
        this.onAdd.emit({ id:response.id });
        await this._utilService.showSWALSuccess({ text: 'SUCCESS_ADD_CUSTOMER_REFERENT' });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: 'ERROR_ADD_CUSTOMER_REFERENT' });
      });

    this.closeModal();
  }

  closeModal() {
    this._modalService.dismissAll();
    this.formGroupAdd.reset();
    this.callbackFn.emit();
  }
}
